import React from "react";
import { Button as KendoButton } from '@progress/kendo-react-buttons';

export const Button = ({themeColor = buttonThemeColors.base, ...otherProps}) => {

    return (
        <KendoButton
            themeColor={themeColor}
            {...otherProps}
        >
            {otherProps.children}
        </KendoButton>
    );
};

export const buttonThemeColors = {
    base: "base",
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
    info: "info",
    success: "success",
    warning: "warning",
    error: "error",
}
